import type React from 'react';

import type { SkeletonProps as ReactLoadingSkeletonProps } from 'react-loading-skeleton';
import ReactLoadingSkeleton from 'react-loading-skeleton';
import { useTheme } from 'styled-components';

import 'react-loading-skeleton/dist/skeleton.css';

export interface SkeletonProps extends ReactLoadingSkeletonProps {
  inverse?: boolean;
  inFlexContainer?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({
  inverse = false,
  inFlexContainer = false,
  ...props
}) => {
  const {
    activeColorScheme: { colors, type },
  } = useTheme() as any;

  // Default colours:
  // - Light theme: use library defaults (undefined) to keep existing look
  // - Dark theme: use semantic background skeleton colours so loaders are dark
  const baseColor = inverse
    ? colors.backgroundBrandInverse
    : type === 'dark'
      ? colors.backgroundSkeleton
      : undefined;

  const highlightColor = inverse
    ? colors.backgroundPage
    : type === 'dark'
      ? colors.backgroundHover
      : undefined;

  return (
    <ReactLoadingSkeleton
      {...props}
      baseColor={baseColor}
      containerClassName={
        inFlexContainer ? 'skeletonInFlexContainer' : undefined
      }
      duration={2}
      highlightColor={highlightColor}
    />
  );
};

export default Skeleton;
